export default function getFormattedDate(timestamp) {
  const datetime = new Date(timestamp * 1000);

  return new Intl.DateTimeFormat('pt-BR', {
    month: 'long',
    day: 'numeric'
  }).format(datetime);
}
